import { ApiRequest } from "../../Common";
import { Trigger } from "../Models/Trigger";
import { endpoints } from "../Constants/endpoints";

// eslint-disable-next-line consistent-return
export const getTriggers = async () => {
  const response = await ApiRequest.fromPath(endpoints.getAllTriggers())
    .withAuthHeader()
    .get();
  if (response.ok) {
    const triggersResponse: { payload: Trigger[] } = await response.json();
    return triggersResponse.payload;
  }
  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }
};
